import ExpandableTable from '../../components/Tables/ExpandableTable';
import { presalesReportColumns } from '../../modules/Reports/columns';
import EmptyDataBlock from '../../modules/Reports/EmptyDataBlock';
import Loader from '../../components/Loader/Loader';
import { useTranslation } from 'react-i18next';
import { useReportPresalesAll } from './useReportPresalesAll';
import { sortByName } from '../../constants/sort-order';
import './ReportPresalesAll.scss';

const EXPENDED_ROW_STYLE = {
  color: '#171717',
  fontWeight: 400,
  fontSize: 14,
};

const ReportPresalesAll = () => {
  const { t } = useTranslation();

  const {
    presalesAllTableData,
    ROW_DEPTH,
    expandByDefault,
    goToEmployee,
    tableRef,
    setExpandedRowId,
    totalClientHours,
    totalClientCost,
    isLoading,
  } = useReportPresalesAll();

  return (
    <>
      {presalesAllTableData?.length ? (
        <ExpandableTable
          columns={presalesReportColumns(t, ROW_DEPTH)}
          data={presalesAllTableData}
          expandedRowId={expandByDefault}
          expandedRowKey='expandedClient'
          expandedRowStyle={EXPENDED_ROW_STYLE}
          onRowClick={goToEmployee}
          ref={tableRef}
          rowDepth={ROW_DEPTH}
          setExpandedRowId={setExpandedRowId}
          sortOrder={sortByName}
          tableName='total-reports-list'
        />
      ) : (
        <EmptyDataBlock />
      )}
      {presalesAllTableData?.length > 1 ? (
        <div className='total_row'>
          <div className='total_title'>All clients</div>
          <div className='total_row_wrapper'>
            <div className='total_duration'>{totalClientHours}</div>
            <div className='total_costs'>
              <span style={{ color: 'green' }}>${totalClientCost}</span>
            </div>
          </div>
        </div>
      ) : null}
      {isLoading && <Loader />}
    </>
  );
};

export default ReportPresalesAll;
